// ProSolve Hub design tokens (from the prosolvedemo2 prototype)
export const assetTheme = {
  tealBrand: '#30cfe5',
  tealDark: '#009db7',
  tealLight: '#c1f1f7',
  teal50: '#f2fcfe',
  teal100: '#e4f8fc',
  midnight: '#001323',
  yellow: '#ffc943',
  yellowEdge: '#e8ae1a',
  bg: '#f4f6f8',
  surface: '#ffffff',
  card2: '#f8f9fb',
  border: '#e6eaf0',
  borderStrong: '#d5dce5',
  text: '#001323',
  muted: '#4a6577',
  faint: '#8897a8',
  action: '#009db7',
  fontFamily: `Inter, -apple-system, 'Segoe UI', Roboto, sans-serif`,
}

export const formatDate = (dateValue) => {
  if (!dateValue) return '';
  const date = new Date(dateValue);
  if (isNaN(date.getTime())) return '';
  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}
